<template>
  <div id="doctor-banner">
    <img src="../../../../assets/images/blueCross/doctorBanner.png" alt="" />
  </div>
</template>

<script>
export default {
  name: "Index",
  components: {}
};
</script>

<style lang="scss" scoped>
#doctor-banner {
  width: 100%;
  height: 600px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
